/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Checkbox/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.module.css"
import Check from 'DesignSystem/Svgs/Check/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Checkbox({
  children,
  viewPath = "/DesignSystem/Checkbox",
  isDisabled,
  marginTop = 0,
  marginRight = 0,
  marginLeft = 0,
  onClick,
  isSelected,
  backgroundColorSelected = "rgb(0,206,124)",
  borderColorSelected = "rgb(0,206,124)",
  borderColorHovered = "rgba(0, 188, 112, 0.83)",
  strokeSelected = "#ffffff",
  textWidth = "auto",
  color = "#323232",
  fontSize = 14,
  text = "Yes, send me text notifications"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled,isSelected})
  return (<React.Fragment
>
<button
  data-testid="Checkbox.Checkbox:1"
  data-view-path={viewPath}
 disabled={isDisabled}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--mt-1-1SENI3': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-2-1SENI3': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-3-1SENI3': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft}}
 className={`views-block ${styles.Checkbox1}`}
>
<div
  data-testid="Checkbox.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-4-1SENI3': isSelected ? backgroundColorSelected : "#ffffff",'--bc-5-1SENI3': isSelected ? borderColorSelected : isHovered ? borderColorHovered : "#ebebeb"}}
 className={`views-block ${styles.Horizontal}`}
>
<Check
  viewPath={`${viewPath}/Check`}
 height={14}
 stroke={isSelected ? strokeSelected : "rgba(0, 0, 0, 0)"}
 width={14}
 opacity={isSelected ? 1 : 0}
/>
</div>
<div
  data-testid="Checkbox.Horizontal:1"
  data-view-path={viewPath}
 style={{'--w-6-1SENI3': typeof textWidth === 'number' ? `${textWidth}px` : textWidth}}
 className={`views-block ${styles.Horizontal1}`}
>
<span
  data-testid="Checkbox.Text"
  data-view-path={viewPath}
 style={{'--c-7-1SENI3': color,'--fs-8-1SENI3': typeof fontSize === 'number' ? `${fontSize}px` : fontSize}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</div>
</button>
{children}
</React.Fragment>)
}